export class EntityTypeModel {
  id: string;
  name: string;
  sort_order: number;
  audit_sequence: number;
  active: boolean;
  entities: any[];
  entity_type_access: any[];
}
